__turbopack_context__.v({
  "ctaButton": "Accessibility-module__YdNWEa__ctaButton",
  "ctaSection": "Accessibility-module__YdNWEa__ctaSection",
  "ctaTitle": "Accessibility-module__YdNWEa__ctaTitle",
  "emailLink": "Accessibility-module__YdNWEa__emailLink",
  "lastUpdated": "Accessibility-module__YdNWEa__lastUpdated",
  "mainContent": "Accessibility-module__YdNWEa__mainContent",
  "measureItem": "Accessibility-module__YdNWEa__measureItem",
  "measuresList": "Accessibility-module__YdNWEa__measuresList",
  "section": "Accessibility-module__YdNWEa__section",
  "sectionText": "Accessibility-module__YdNWEa__sectionText",
  "sectionTitle": "Accessibility-module__YdNWEa__sectionTitle",
});
